export default __webpack_public_path__ + "static/media/0410e0e7064f9737bd2e731eabf861061581616830075.3c8ff8fd.webp";